export default function GeneralIcon(props: { fill?: string }) {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4264_12825)">
        <path
          d="M22.5443 8.25907C22.5443 8.00435 22.3359 7.79595 22.0812 7.79595H16.0606C15.8059 7.79595 15.5975 7.58754 15.5975 7.33283V1.31224C15.5975 1.05753 15.3891 0.849121 15.1343 0.849121H7.7244C7.46968 0.849121 7.26128 1.05753 7.26128 1.31224V7.33283C7.26128 7.58754 7.05288 7.79595 6.79816 7.79595H0.777575C0.522858 7.79595 0.314453 8.00435 0.314453 8.25907V15.669C0.314453 15.9237 0.522858 16.1321 0.777575 16.1321H6.79816C7.05288 16.1321 7.26128 16.3405 7.26128 16.5953V22.6158C7.26128 22.8706 7.46968 23.079 7.7244 23.079H15.1343C15.3891 23.079 15.5975 22.8706 15.5975 22.6158V16.5953C15.5975 16.3405 15.8059 16.1321 16.0606 16.1321H22.0812C22.3359 16.1321 22.5443 15.9237 22.5443 15.669V8.25907Z"
          fill={props.fill ?? 'white'}
        />
      </g>
      <defs>
        <clipPath id="clip0_4264_12825">
          <rect
            width="22.2298"
            height="22.2298"
            fill={props.fill ?? 'white'}
            transform="translate(0.314453 0.849121)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
